import type { RootState } from "@src/store/rootState";
import { basicModSlice } from "@src/store/slices/experienceBuilder/basicMod/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export function getVariationInitialDraft(state: RootState) {
  const mod = basicModSlice.selectors.getInitialDraft(state);
  const variationId = experienceBuilderSlice.selectors.getVariationId(state);
  return mod?.variationId === variationId ? mod : undefined;
}
